import React from 'react';
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";


import classes from './Information.css';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';

import {getCurrentTimezone} from '../../../store/utility';

class Information extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedEvent: null, 
            selectedEventElement: null,
            invalidFirstName: false,
            invalidLastName: false,
            invalidEmail: false,
        }

        /* 1. Initialize Input Ref */
        this.firstNameInput = React.createRef(); 
        this.lastNameInput = React.createRef(); 
        this.emailInput = React.createRef(); 
        this.infoInput = React.createRef(); 
        this.contactMethodInput = React.createRef();

        this.defaultInfo = "Hello, let's have a chat for 30 mins. We can talk about anything, life, work...etc. Please contact me using contact method mentioned above.";
    }

    handleConfirmBooking() {

        // verify information
        let validation_failed = false;

        // first name validation
        if (this.firstNameInput.current.value.trim()==='') {
            validation_failed = false;
            this.setState({invalidFirstName: true})
        } else {
            this.setState({invalidFirstName: false})
        }

        // last name validation
        if (this.lastNameInput.current.value.trim()==='') {
            validation_failed = true;
            this.setState({invalidLastName: true})
        } else {
            this.setState({invalidLastName: false})
        }

        // email validation
        if ( (this.emailInput.current.value.trim()==='') 
            | (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.emailInput.current.value)===false) ) 
        {
            validation_failed = true;
            this.setState({invalidEmail: true})
        }
        else {
            this.setState({invalidEmail: false})
        }

        if (validation_failed===true) {
            return; // return if validation failed
        }

        // process information

        /* 3. Get Ref Value here (or anywhere in the code!) */
        let info = {
            first_name: this.firstNameInput.current.value,
            last_name: this.lastNameInput.current.value,
            email: this.emailInput.current.value,
            info: (this.infoInput.current.value.trim()==='') ? this.defaultInfo : this.infoInput.current.value,
            // contact_method: this.contactMethodInput.current.value,
            timezone: getCurrentTimezone(),
        };
        if (this.contactMethodInput.current) {
            info.contact_method = this.contactMethodInput.current.value;
        }
        this.props.bookCallback(info);
    }

    render() {        

        let inputSize;
        if (this.props.isMobile===true) {
            inputSize = 'none';
        }
        else {
            inputSize = "none";
        }

        // create contact_method_options if contact_method_options not empty
        let contact_method_options_content = null;
        let emailColSize = 12;
        if (this.props.contact_method_options.length !== 0) { 

            contact_method_options_content = (
                <Col lg={6}>
                <Form.Group controlId="formGridState">
                <Form.Label><b>Contact Method</b></Form.Label>
                <Form.Control ref={this.contactMethodInput} size={inputSize} as="select" >
                    { 
                        this.props.contact_method_options.map((contact_method_option, index) => (
                        <option key={index}>{contact_method_option.id}</option> )) 
                    }
                </Form.Control>
                </Form.Group>
                </Col>
            )
            emailColSize = 6;
        }
        
        return (
            <Container className={classes.Information}>
            <div className={classes.InformationForm}>
                <Form>
                    <Row>
                        <Col lg={6}>
                            <Form.Group controlId="userName">
                                <Form.Label><b>First Name</b></Form.Label>
                                <Form.Control ref={this.firstNameInput} size={inputSize} isInvalid={this.state.invalidFirstName} 
                                    type="text" placeholder="first name" defaultValue={this.props.firstName}/>
                                <Form.Control.Feedback type="invalid">first name is required</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group controlId="userName">
                                <Form.Label><b>Last Name</b></Form.Label>
                                <Form.Control ref={this.lastNameInput} size={inputSize} isInvalid={this.state.invalidLastName} 
                                    type="text" placeholder="last name" defaultValue={this.props.lastName}/>
                                <Form.Control.Feedback type="invalid">last name is required</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={emailColSize}>
                            <Form.Group controlId="email">
                                <Form.Label><b>Email</b></Form.Label>
                                <Form.Control ref={this.emailInput} size={inputSize} isInvalid={this.state.invalidEmail} 
                                    type="email" placeholder="email" defaultValue={this.props.email}/>
                                <Form.Control.Feedback type="invalid">invalid email</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        { contact_method_options_content }
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="info">
                                <Form.Label><b>Details</b>
                                <Form.Text className="text-muted">
                                    Please leave your preferred contact method in the details as well.
                                </Form.Text>
                                </Form.Label>
                                <Form.Control ref={this.infoInput} as="textarea" rows="4" placeholder={ this.defaultInfo }/>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </div>
            <Row className={classes.Back}>
                <Col>
                    <Button variant="info" size={inputSize} onClick={()=>this.handleConfirmBooking()}>Confirm Booking</Button>
                </Col>
            </Row>
            <Row className={classes.Book}>
                <Col>
                    <Button variant="outline-info" size={inputSize} onClick={()=>this.props.goBack()}>Go Back</Button>
                </Col>
            </Row>
            </Container>
        )
    }
}

export default Information;


// WEBPACK FOOTER //
// ./src/containers/Schedule/Information/Information.js